import getHelper from '../../../services/getHelper';
import type { FundingRequest } from '../../../../../index';

export default getHelper<FundingRequest>('/funding-requests/:id');
